export const getApiWidgetTypeConfig = (widgetType) => ({
  headers: {
    'X-Widget-Type': widgetType
  }
});
